export default __webpack_public_path__ + "locales/sq-AL/EmbeddingPanel.json?hash=7f90be30f53b1e8373036a59cdb659e2";